import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { PlatformLocation } from '@angular/common';

export class CompatibilitySkipModalContext {
    public title: string;
    public hasCloseLink?: boolean;
    public customClass?: string;
    public notBeforeSkipping?: boolean;
}

@Component({
    selector: 'app-compatibility-skip-modal',
    templateUrl: './skip-device-modal.component.html'
})
export class CompatibilitySkipModalComponent {
    public context: any;

    constructor(@Inject(MAT_DIALOG_DATA) public data: any, public dialog: MatDialogRef<CompatibilitySkipModalContext>, private location: PlatformLocation) {
        location.onPopState(() => {this.beforeDismiss();this.dialog.close();});
        this.context = data;
    }

    public skipModalOption(skipResult?): void {
        let selectedOption = '';

        if (!!skipResult) {
            selectedOption = 'physical';
        } else {
            selectedOption = null;
        }
        this.beforeDismiss();
        this.dialog.close(selectedOption);
    }

    beforeClose(): boolean {
        if (document.body.classList.contains('modal-open')) {
            document.body.classList.remove('modal-open');
        }
        return false;
    }

    beforeDismiss(): boolean {
        return this.beforeClose();
    }

    closeDialog(): void {
        this.beforeDismiss();
        this.dialog.close();
    }
}
